import type { ChannelClient } from '@hibro/platform-core';
import {
  type LinkedModulesBridge,
  type LogBridge,
  type OsNotificationBridge,
  SettingsPanel,
} from '@hibro/platform-renderer';
import type {
  IAppLinkService,
  IConfigurationService,
  ILauncherService,
  IPermissionService,
  ISearchRecentService,
} from '@hibro/shared';
import type { ReactNode } from 'react';

import type { PickLocalBundle } from './bundle-bridge';
import { useSettingsCapabilityBridges } from './settings-capability-bridges';

/**
 * The existing platform settings body, without its modal shell, for the
 * preferences window's developer options.
 */
export function EmbeddedPlatformSettings({
  client,
  configService,
  permissionService,
  launcherService,
  appLinkService,
  searchRecentService,
  logBridge,
  linkedModulesBridge,
  osNotificationBridge,
  pickLocalBundle,
}: {
  client: ChannelClient;
  configService: IConfigurationService;
  permissionService: IPermissionService;
  launcherService: ILauncherService;
  appLinkService: IAppLinkService;
  searchRecentService: ISearchRecentService;
  logBridge?: LogBridge;
  linkedModulesBridge?: LinkedModulesBridge;
  osNotificationBridge?: OsNotificationBridge;
  pickLocalBundle?: PickLocalBundle;
}): ReactNode {
  const bridges = useSettingsCapabilityBridges(client, pickLocalBundle);
  return (
    <SettingsPanel
      embedded
      configService={configService}
      permissionService={permissionService}
      client={client}
      launcherService={launcherService}
      appLinkService={appLinkService}
      searchRecentService={searchRecentService}
      bundleBridge={bridges.bundleBridge}
      logBridge={logBridge}
      devtoolsBridge={bridges.devtoolsBridge}
      linkedModulesBridge={linkedModulesBridge}
      osNotificationBridge={osNotificationBridge}
      autoLaunchBridge={bridges.autoLaunchBridge}
      onClose={() => undefined}
    />
  );
}
